import React from 'react';
//import { Loader } from '../Loader';
import styles from './button.module.scss';

export function Button(props) {
  const {
    loading,
    disabled,
    label,
    color,
    icon,
    onClick,
    fullWidth,
    customStyle,
  } = props;

  return (
    <button
      style={customStyle}
      className={[
        styles['container'],
        styles[color || 'primary'],
        fullWidth ? styles['fullWidth'] : '',
      ].join(' ')}
      onClick={onClick}
      disabled={disabled}
    >
      {loading ? (
     //   <Loader />
     <h6>loading...</h6>
      ) : (
        <>
          {icon && <img src={icon} alt={label} />}
          {label && <span className={styles['btn-text']}>{label}</span>}
        </>
      )}
    </button>
  );
}
